export default __webpack_public_path__ + "static/media/logo-tiktok.248f54ef.svg";